<template>

    <div>
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="{name:child.route}">
                        {{ child.name }}
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view></router-view>
    </div>

</template>

<script>

    import MenuItem from "../../Libraries/MenuItem";
    import FixedTabs from "../../Libraries/FixedTabs";

    export default {

        computed: {
            getMenu() {
                return [
                    new MenuItem('Afbeeldingen', 'images.index'),
                    new MenuItem('Nieuwe afbeeldingen', 'images.pending.index'),
                ];
            }
        },

        destroyed(){
            FixedTabs.unset();
        },

        methods: {
            isActiveChildRoute(child) {
                return child.route === this.$route.name;
            },
        },

        mounted(){
            FixedTabs.set();

            if (document.getElementById('has-waiting-tickets')) {
                document.querySelector('.nav-tabs-custom .nav-fixed-tabs').style.setProperty('top', '105px', 'important');
            }
        },

        name:'ImagesLayout',

    }

</script>
